import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComplementoWebService } from '../../../../services/complemento-web/complemento-web.service';
import { AppState } from '../../../../@store/app.reducers';
import { Store } from '@ngrx/store';
import { selectDetalleSiniestroSiniestros, selectListaCatalogosTerceroSiniestros, selectObjetoDetalleSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ConsultaMarcasOutput, ConsultaModelosOutput, ConsultaSubTiposOutput, ConsultaVehiculosOutput, DatoGenerico, ModeloVehiculo, Prestadores, Vehiculo } from '../../../../models/complementos-web/complementos-web-terceros.model';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from '../../../../@store/actions';
import { ResultApiResponse } from '../../../../models/complementos-web/complementos-web-servicios.model';
import { FormControl, FormGroup, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { combineLatest, skipWhile, Subscription, take } from 'rxjs';
import * as compleWeb from '../../@store/complemento-web/complemento-web.actions';
import { ModalConsultarVehiculosComponent } from '../../@modals/modal-consultar-vehiculos/modal-consultar-vehiculos.component';
import { MatDialog } from '@angular/material/dialog';
import { ConsultaDireccionOutput, ConsultaSiniestroOutput, TerceroComplemento } from 'src/app/models/complementos-web/complementos-web.model';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { DomSanitizer } from '@angular/platform-browser';
import { emailValidator, importeMayorACeroValidator } from '../../@validators/validators-complemento';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { NgClass } from '@angular/common';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { UpperCaseTextDirective } from '../../../../@shared/directives/upper-case.directive';
import { OnlyNumber } from '../../../../@shared/directives/only-number.directive';
import { FormatoNumeroMonedaCoplementoWebDirective } from '../../@directives/formato-numero-moneda.directiva';
import { MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-alta-tipo-terceros',
    templateUrl: './alta-tipo-terceros.component.html',
    styleUrls: ['./alta-tipo-terceros.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgClass, MatFormField, MatLabel, MatSelect, MatOption, MatError, MatInput, UpperCaseTextDirective, OnlyNumber, FormatoNumeroMonedaCoplementoWebDirective, MatMiniFabButton, MatIcon, MatSuffix, MatMenuTrigger, MatMenu]
})
export class AltaTipoTercerosComponent implements OnInit, OnChanges {

  @Input() tercero: TerceroComplemento;
  @Input() modulo: string;

  @Output() eventoTercero = new EventEmitter<{ nombre: string, valor: any }>();

  public catTipoTercero: Array<DatoGenerico> = [];
  public catCategorias: Array<DatoGenerico> = [];
  public catTpoPersona: Array<DatoGenerico> = [];
  public catCompania: Array<Prestadores> = [];
  public catEstatus: Array<DatoGenerico> = [];
  public catTodosEstatus: Array<DatoGenerico> = [];

  public catModelo: ModeloVehiculo[] = [];
  public catVehiculos: Vehiculo[] = [];
  public catSubTipoVehiculos: any[] = [];
  public catMarcasVehiculos: any[] = [];
  public catModelosVehiculos: any[] = [];
  public catColores: any[] = [];
  public catCoberturas: any[] = [];

  public formAltaTercero: FormGroup;
  public listaObservables = new Subscription();

  public habilitaTerceroAlta: boolean = false;
  public detalleSiniestroBase: any;
  public detalleSiniestroCompleto: ConsultaSiniestroOutput;
  public terceroSeleccionado: TerceroComplemento;


  public cesvi = { estatus_cesvi: 0, error_serie: "", intento: 0, error_digitos: 0 };
  public verificaSerieHTML = '';
  public verificaSerieHTMLSa;
  public showTooltip = false;

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private complementoWebService: ComplementoWebService,
    private procesosComplementService: ProcesosComunesComplementoService,
    private sanitizer: DomSanitizer
  ) {
    this.crearFormulario();
    this.obtenerCatalogos();
    this.cargarCatalgosTerceroSiniestro();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["tercero"]?.currentValue) {
      this.consultaTercero(changes["tercero"]?.currentValue?.id_tercero);
    }
  }

  ngOnInit(): void {
    this.cambiosFormulario();
  }

  obtenerCatalogos() {
    const subsRedux = combineLatest([
      this.store.select(selectListaCatalogosTerceroSiniestros),
      this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)),
      this.store.select(selectDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null))
    ]).subscribe(([catalogos, detalleCompleto, detalleBase]) => {
      this.catTipoTercero = catalogos.consultaTipoTercero;
      this.catCategorias = catalogos.consultaCategorias;
      this.catTpoPersona = catalogos.consultaTipoPersona?.filter(tp => [1, 2].includes(tp.valor_dato));
      this.catEstatus = catalogos.consultaEstatus;
      this.catTodosEstatus = catalogos.consultaEstatus;
      this.catCompania = catalogos.consultaCompanias;
      this.catColores = catalogos.consultaColores;
      this.catCoberturas = catalogos.consultaCoberturas;

      this.detalleSiniestroCompleto = detalleCompleto;
      this.detalleSiniestroBase = detalleBase;
    });
    this.listaObservables.add(subsRedux);
  }

  cargarCatalgosTerceroSiniestro() {
    this.store.dispatch(compleWeb.SolicitudCatalogosTerceroDetalleComplementoAction());
  }

  crearFormulario() {
    this.formAltaTercero = new FormGroup({
      tipoTercero: new FormControl(null),
      tipoPersona: new FormControl(null),
      idTercero: new FormControl(null),
      razonSocial: new FormControl(null),
      nombre: new FormControl(null),
      apellidoPaterno: new FormControl(null),
      apellidoMaterno: new FormControl(null),
      cobertura: new FormControl(null),
      siniestro: new FormControl(null),
      ajustador: new FormControl(null),
      poliza: new FormControl(null),
      email: new FormControl(null, [emailValidator(), Validators.email]),
      telefono: new FormControl(null, [Validators.maxLength(10)]),
      compania: new FormControl(null),
      descripcionCompania: new FormControl(null),
      estatus: new FormControl(null, []),
      categoria: new FormControl(null),
      descripcion: new FormControl(null),
      modelo: new FormControl(null),
      marca: new FormControl(null),
      subTipo: new FormControl(null),
      vehiculo: new FormControl(null),
      color: new FormControl(null),
      placas: new FormControl(null),
      serie: new FormControl(null),
      motor: new FormControl(null),

      edad: new FormControl(null),
      objetoDanado: new FormControl(null),
      importe: new FormControl(null),

    })
  }

  cambiosFormulario() {
    const subsTipoTercero = this.formAltaTercero.get('tipoTercero')?.valueChanges.subscribe({
      next: (value) => {
        console.log(value)
        if(value == 1) {
          this.catEstatus = this.catTodosEstatus;
        }
        if (value == 2) {
          this.catEstatus = this.catTodosEstatus.filter(estatus => [1, 3, 5, 6].includes(estatus.valor_dato));
        }
        if (value == 3) {
          this.catEstatus = this.catTodosEstatus.filter(estatus => [1, 3, 5, 6].includes(estatus.valor_dato));
        }
        if (value == 4) {
          this.catEstatus = this.catTodosEstatus.filter(estatus => [1, 3, 5, 6, 7].includes(estatus.valor_dato));
        }
        if (value == 5) {
          this.catEstatus = this.catTodosEstatus.filter(estatus => [1, 3, 5, 6, 7].includes(estatus.valor_dato));
        }
        if (value == 1) {
          this.actualizaValidadores(this.formAltaTercero, [
            'edad',
          ], 'quitar');
          this.actualizaValidadores(this.formAltaTercero, [
            'tipoPersona', 'nombre',
            'apellidoPaterno', 'apellidoMaterno',
            'categoria',
            'modelo',
            'marca',
            'subTipo',
            'vehiculo',
            'color',
            'placas',
            'serie',
            'cobertura',
          ], 'agregar', [Validators.required]);
          return this.actualizaValidadores(this.formAltaTercero, [
            'estatus',
          ], 'agregar', [Validators.required, importeMayorACeroValidator()]);
        }
        if ([2, 3].includes(value)) {
          this.actualizaValidadores(this.formAltaTercero, [
            'siniestro', 'poliza',
            'edad',
            'compania',
            'categoria',
            'modelo',
            'marca',
            'subTipo',
            'vehiculo',
            'color',
            'placas',
            'serie',
            'cobertura',
          ], 'quitar');
          this.actualizaValidadores(this.formAltaTercero, [
            'tipoPersona', 'nombre',
            'apellidoPaterno', 'apellidoMaterno',
          ], 'agregar', [Validators.required]);
          return this.actualizaValidadores(this.formAltaTercero, [
            'estatus',
          ], 'agregar', [Validators.required, importeMayorACeroValidator()]);
        }
        if ([4, 5].includes(value)) {
          this.actualizaValidadores(this.formAltaTercero, [
            'siniestro', 'poliza',
            'tipoPersona',
            'compania',
            'categoria',
            'modelo',
            'marca',
            'subTipo',
            'vehiculo',
            'color',
            'placas',
            'serie',
            'cobertura',
          ], 'quitar');
          this.actualizaValidadores(this.formAltaTercero, [
            'nombre',
            'apellidoPaterno', 'apellidoMaterno',
            'edad'
          ], 'agregar', [Validators.required]);
          return this.actualizaValidadores(this.formAltaTercero, [
            'estatus',
          ], 'agregar', [Validators.required, importeMayorACeroValidator()]);
        }
        this.quitaTodosLosValidadores();

      },
    });
    const subsTipoCobertura = this.formAltaTercero.get('cobertura')?.valueChanges.subscribe({
      next: (value) => {
        if (value != 0 && this.formAltaTercero.get('tipoTercero').value == 1) {
          this.actualizaValidadores(this.formAltaTercero, [
            'siniestro', 'poliza', 'compania'
          ], 'agregar', [Validators.required]);
        } else {
          this.actualizaValidadores(this.formAltaTercero, [
            'siniestro', 'poliza', 'compania'
          ], 'quitar');
        }
      },
    });
    const subsTipoPersona = this.formAltaTercero.get('tipoPersona')?.valueChanges.subscribe({
      next: (value) => {
        if (value == 1) {
          this.formAltaTercero.get('razonSocial').reset(null);
          this.formAltaTercero.get('razonSocial').setValidators(null)
          this.formAltaTercero.get('razonSocial').updateValueAndValidity();
        } else {
          this.formAltaTercero.get('razonSocial').reset(null);
          this.formAltaTercero.get('razonSocial').setValidators(Validators.required)
          this.formAltaTercero.get('razonSocial').updateValueAndValidity();
        }
      },
    });
    const subsCategoria = this.formAltaTercero.get('categoria')?.valueChanges.subscribe({
      next: (value) => {
        this.formAltaTercero.patchValue({
          modelo: null,
          marca: null,
          subTipo: null,
          vehiculo: null,
        }, { emitEvent: false }); // Evita ciclos innecesarios
        this.obtenerModelosPorCategoria(value);
      },
    });
    const subsModelo = this.formAltaTercero.get('modelo')?.valueChanges.subscribe({
      next: (value) => {
        this.formAltaTercero.patchValue({
          marca: null,
          subTipo: null,
          vehiculo: null,
        }, { emitEvent: false });
        const { categoria } = this.formAltaTercero.getRawValue();
        this.obtenerMarcaPorCategoriaModelo(categoria, value);
      },
    });
    const subsMarca = this.formAltaTercero.get('marca')?.valueChanges.subscribe({
      next: (value) => {
        this.formAltaTercero.patchValue({
          subTipo: null,
          vehiculo: null,
        }, { emitEvent: false });
        const { categoria, modelo } = this.formAltaTercero.getRawValue();
        this.obtenerSubtiposPorModeloMarca(categoria, modelo, value);
      },
    });
    const subsSubtipos = this.formAltaTercero.get('subTipo')?.valueChanges.subscribe({
      next: (value) => {
        this.formAltaTercero.patchValue({
          vehiculo: null,
        }, { emitEvent: false });
        const { categoria, modelo, marca, descripcion } = this.formAltaTercero.getRawValue();
        this.obtenerVehiculosPorModeloCategoria(categoria, modelo, descripcion, marca, value);
      },
    });
    this.listaObservables.add(subsTipoTercero);
    this.listaObservables.add(subsCategoria);
    this.listaObservables.add(subsTipoCobertura);
    this.listaObservables.add(subsModelo);
    this.listaObservables.add(subsTipoPersona);
    this.listaObservables.add(subsMarca);
    this.listaObservables.add(subsSubtipos);
  }

  obtenerModelosPorCategoria(categoria: number) {
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaModelos({ categoria }).subscribe({
      next: (value: ResultApiResponse<ConsultaModelosOutput>) => {
        this.catModelo = value.Resultado.Modelos;
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
    })
  }

  obtenerMarcaPorCategoriaModelo(categoria: number, modelos: number = 0) {
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      categoria,
      modelo: modelos
    };
    this.complementoWebService.consultaMarcas(request).subscribe({
      next: (value: ResultApiResponse<ConsultaMarcasOutput>) => {
        this.catMarcasVehiculos = value.Resultado.Marcas ?? [];
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
    })
  }

  obtenerSubtiposPorModeloMarca(categoria: number, modelos: number, marca: number = 0) {
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      categoria,
      modelo: modelos,
      marca,
    };
    this.complementoWebService.consultaSubTipos(request).subscribe({
      next: (value: ResultApiResponse<ConsultaSubTiposOutput>) => {
        this.catSubTipoVehiculos = value.Resultado.SubTipos ?? [];
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
    })
  }

  obtenerVehiculosPorModeloCategoria(categoria: number, modelos: number, descripcion: string, marca: number = 0, subTipo: number = 0) {
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      categoria,
      modelo: modelos,
      marca,
      subTipo,
      descripcion
    };
    this.complementoWebService.consultaVehiculos(request).subscribe({
      next: (value: ResultApiResponse<ConsultaVehiculosOutput>) => {
        this.catVehiculos = value.Resultado?.Vehiculos ?? [];
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
    })
  }

  setearUsuario(tercero: TerceroComplemento) {
    this.formAltaTercero.patchValue({
      tipoTercero: tercero?.tipo_tercero,
      idTercero: tercero?.id_tercero,
      tipoPersona: tercero?.tipo_persona == 'F' ? 1 : 2,
      razonSocial: tercero?.razon_social,
      nombre: tercero?.nombre,
      apellidoPaterno: tercero?.ap_paterno,
      apellidoMaterno: tercero?.ap_materno,
      cobertura: tercero?.cobertura_tercero,
      siniestro: tercero?.siniestro,
      ajustador: tercero?.ajustador,
      poliza: tercero?.poliza,
      email: tercero?.email,
      telefono: tercero?.telefono,
      compania: tercero?.cve_cia_aseg,
      descripcionCompania: tercero?.desc_cia_aseg,
      estatus: tercero?.estatus_tercero,
      // categoria: tercero?.cve_categoria,
      // modelo: tercero?.modelo,
      // marca: tercero?.marca,
      // subTipo: tercero?.subtipo,
      // vehiculo: tercero?.vehiculo,
      color: tercero?.color,
      placas: tercero?.placas,
      serie: tercero?.serie,
      motor: tercero?.motor,

      edad: tercero?.edad,
      objetoDanado: tercero?.objeto_danado,
      importe: tercero.importe != "$.00" ? parseFloat(tercero.importe.replace(/[$,]/g, '')) : 0,
    });

    this.formAltaTercero.patchValue({
      categoria: tercero?.cve_categoria,
      modelo: tercero?.modelo,
      marca: tercero?.cve_marca,
    });
    setTimeout(() => {
      this.formAltaTercero.patchValue({
        subTipo: tercero?.subtipo,
        vehiculo: tercero?.cve_vehiculo,
      });
    }, 1000);
  }

  abrirModalVehiculos() {
    const dialog = this.dialog.open(ModalConsultarVehiculosComponent, {
      width: '900px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { categoria: this.formAltaTercero.get('categoria').value },
    }).afterClosed().subscribe(data => {
      if (data != null) {
        this.formAltaTercero.patchValue({
          categoria: data?.categoria,
          modelo: data?.modelo,
          marca: data?.cve_marca,
          descripcion: data?.descripcion
        });
        setTimeout(() => {
          this.formAltaTercero.patchValue({
            subTipo: data?.cve_subtipo,
            vehiculo: data?.cve_vehiculo,
          });
        }, 1000);
      }
    });
  }

  consultaTercero(idTercero: number) {
    if (!idTercero) return;
    const siniestroFormateado = this.procesosComplementService.devolverSiniestro(this.detalleSiniestroBase?.siniestroCompleto);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      id_tercero: idTercero
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaTerceros(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado != null) {
          const tercero = value.Resultado.Terceros[0];
          this.setearUsuario(tercero);
          this.terceroSeleccionado = tercero;
        } else {
          this.procesosComplementService.alertaGeneralComplemento('Aviso', `No se encontró el detalle del tercero.`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos del complemento.' }));
      },
    })
  }

  guardarActualizarTercero(tercero?: TerceroComplemento) {
    this.limpiarNotificacionSerie();
    if (!this.formAltaTercero.valid) {
      this.procesosComplementService.alertaGeneralComplemento('Aviso', '', 'warning', false, true, "Debes capturar los campos requeridos");
      return this.formAltaTercero.markAllAsTouched();
    }
    const siniestroFormateado = this.procesosComplementService.devolverSiniestro(this.detalleSiniestroBase?.siniestroCompleto);
    const perfilAdministrador = this.detalleSiniestroBase?.perfilAdministrador;
    let serieNormal = ((this.detalleSiniestroCompleto.Siniestro[0].serie_normal == null) ? 0 : this.detalleSiniestroCompleto.Siniestro[0].serie_normal);
    const request = {
      sucursal: this.detalleSiniestroCompleto.Siniestro[0].sucursalk1,
      linea: this.detalleSiniestroCompleto.Siniestro[0].cve_linea,
      producto: this.detalleSiniestroCompleto.Siniestro[0].cve_prod,
      polizak: this.detalleSiniestroCompleto.Siniestro[0].polizak1,
      endoso: this.detalleSiniestroCompleto.Siniestro[0].endosok1,
      a_emision: this.detalleSiniestroCompleto.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSiniestroCompleto.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSiniestroCompleto.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSiniestroCompleto.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSiniestroCompleto.Siniestro[0].num_incisok,
      num_depend: this.detalleSiniestroCompleto.Siniestro[0].num_dependk,
      fechaSiniestro: this.detalleSiniestroCompleto.Siniestro[0].fecsini,
      alarma: this.detalleSiniestroCompleto.Siniestro[0].alarma,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      // tipoCliente
      id_tercero: tercero?.id_tercero ? tercero?.id_tercero : this.formAltaTercero.get('idTercero').value ?? 0,
      nombre: this.formAltaTercero.get("nombre").value ?? "",
      paterno: this.formAltaTercero.get("apellidoPaterno").value ?? "",
      materno: this.formAltaTercero.get("apellidoMaterno").value ?? "",
      placas: this.formAltaTercero.get("placas").value ?? "",
      persona: this.formAltaTercero.get("tipoPersona").value ?? "",
      categoria: this.formAltaTercero.get("categoria").value ?? "",
      vehiculo: this.formAltaTercero.get("vehiculo").value ?? "",
      desc_vehiculo: this.formAltaTercero.get("vehiculo").value ? this.catVehiculos.find(vh => vh.cve_vehiculo == this.formAltaTercero.get("vehiculo").value)?.des_vehiculo : "",
      coberturaTercero: this.formAltaTercero.get("cobertura").value ?? "",
      marca: this.formAltaTercero.get("marca").value ?? "",
      desc_marca: this.formAltaTercero.get("marca").value ? this.catMarcasVehiculos.find(vh => vh.cve_marca == this.formAltaTercero.get("marca").value)?.des_marca : "",
      // siniestro: this.detalleSiniestroBase?.siniestroCompleto,
      siniestro: this.formAltaTercero.get('siniestro')?.value ?? "",
      modelo: this.formAltaTercero.get("modelo").value ?? "",
      ajustador: this.formAltaTercero.get("ajustador").value ?? "",
      color: this.formAltaTercero.get("color").value ?? "",
      poliza: this.formAltaTercero.get("poliza").value ?? "",
      serie: this.formAltaTercero.get("serie").value ?? "",
      correo: this.formAltaTercero.get("email").value ?? "",
      motor: this.formAltaTercero.get("motor").value ?? "",
      telefono: this.formAltaTercero.get("telefono").value ?? "",
      subTipo: this.formAltaTercero.get("subTipo").value ?? "",
      compania: this.formAltaTercero.get("compania").value ?? "",
      estatus: this.formAltaTercero.get("estatus").value ?? "",
      razonSocial: this.formAltaTercero.get("razonSocial").value ?? "",
      tipoTercero: this.formAltaTercero.get("tipoTercero").value ?? "",
      desc_tipoTercero: this.formAltaTercero.get("tipoTercero").value ? this.catTipoTercero.find(vh => vh.valor_dato == this.formAltaTercero.get("tipoTercero").value)?.descripl_dato : "",
      edad: this.formAltaTercero.get("edad").value == null ? "" : this.formAltaTercero.get("edad").value,
      objetoDañado: this.formAltaTercero.get("objetoDanado").value ?? "",
      responsable: this.modulo != 'Lesionados' ? this.detalleSiniestroCompleto.Siniestro[0].respons_sini : 0,
      importe: this.formAltaTercero.get('importe').value ?? "",
    }

    console.log(request)
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.guardaActualizaTercero(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado != null && value.Exito && value.Mensaje == null) {
          if (value.Resultado?.error_serie?.length) {
            this.formAltaTercero.get('idTercero').setValue(value.Resultado.IdTercero);
            this.procesosComplementService.alertaGeneralComplemento('Aviso', "", 'success', false, true, `${value.MensajeSistema}<br> <b>Nota: Se detectaron algunos observaciones en la serie del tercero. </b>`);
            this.cesvi.error_serie = value.Resultado?.error_serie;
            this.cesvi.estatus_cesvi = Number(value.Resultado.estatus_cesvi);
            this.mostrarNotificacionSerie();
            return;
          }

          this.procesosComplementService.alertaGeneralComplemento('Guardado', `La información del tercero se guardó/actualizó correctamente`, 'success', false, true);
          this.eventoTercero.emit({ nombre: 'ACTUALIZAR_COMPLEMENTO', valor: true });
        } else {
          this.procesosComplementService.alertaGeneralComplemento('Aviso', `${value.MensajeSistema || 'No se pudo guardar o actualizar la información del tercero.'}`, 'warning', false, true);
          if (value.Resultado?.error_serie?.length) {
            // this.procesosComplementoService.alertaGeneralComplemento('Aviso', `${value.Resultado?.error_serie}`, 'warning', false, true);
            this.cesvi.error_serie = value.Resultado?.error_serie;
            this.cesvi.estatus_cesvi = Number(value.Resultado.estatus_cesvi);
            this.mostrarNotificacionSerie();
            return;
          }

        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos guardar la información de los terceros.' }));
      },
    })
  }

  actualizaValidadores(
    form: FormGroup,
    campos: string[],
    operacion: 'agregar' | 'quitar',
    validadores: ValidatorFn[] = []
  ): void {
    campos.forEach(campo => {
      const control = form.get(campo);
      if (!control) return;

      if (operacion === 'quitar') {
        control.clearValidators();
        control.setValidators(null);
        control.setValue(null, { emitEvent: false });
      } else if (operacion === 'agregar') {
        control.setValidators(validadores);
        control.setValue(null, { emitEvent: false });
      }
      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  quitaTodosLosValidadores() {
    Object.keys(this.formAltaTercero.controls).forEach(key => {
      const control = this.formAltaTercero.get(key);
      control.clearValidators();
      control.updateValueAndValidity({ emitEvent: false });
    });
  }


  mostrarNotificacionSerie() {
    const tool = this.getTooltipContent();
    this.verificaSerieHTML = tool;
    this.verificaSerieHTMLSa = this.sanitizer.bypassSecurityTrustHtml(tool);
    this.formAltaTercero.get('serie')?.markAsTouched();
    this.formAltaTercero.get('serie')?.setErrors({ incorrecta: true });
  }

  limpiarNotificacionSerie() {
    this.verificaSerieHTML = "";
    this.verificaSerieHTMLSa = null;
    this.cesvi.estatus_cesvi = 0;
    this.cesvi.error_serie = "";
    this.formAltaTercero.get('serie')?.setErrors(null);
  }

  getTooltipContent(): string {
    if (this.cesvi.estatus_cesvi != 0) return '<small style="font-weight : bold; font-size: 10px;">Serie correcta</small>';
    if (this.cesvi.error_serie == null) return;
    const datos = this.cesvi.error_serie.includes("|") ? this.cesvi.error_serie.split('|') : [this.cesvi.error_serie];
    let html = '<ul style="list-style-type: circle; padding: 5px 0px 5px 5px;">';

    datos.forEach(dato => {
      if (dato.includes(')')) {
        dato.split(')').forEach(sub => {
          if (sub.trim()) html += `<li style="font-weight : bold; color:red; font-size: 10px;">${sub})</li>`;
        });
      } else if (dato.trim()) {
        html += `<li style="font-weight : bold; color:red; font-size: 10px;">${dato}</li>`;
      }
    });

    html += '</ul>';
    return html;
  }

  openMenu(trigger: MatMenuTrigger) {
    trigger.openMenu();
  }

  closeMenu(trigger: MatMenuTrigger) {
    trigger.closeMenu();
  }

}